import * as React from 'react';
const MealTagsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g
      stroke={props.color || '#FFFFFF8C'}
      strokeLinecap="round"
      strokeOpacity={0.55}
      strokeWidth={1.333}
      opacity={0.7}
    >
      <path d="M13.333 4.667H2.667A1.333 1.333 0 0 0 1.333 6v4a1.333 1.333 0 0 0 1.334 1.333h10.666A1.333 1.333 0 0 0 14.667 10V6a1.333 1.333 0 0 0-1.334-1.333Z" />
      <path d="M10.667 14V3.333A1.333 1.333 0 0 0 9.333 2H6.667a1.333 1.333 0 0 0-1.334 1.333V14" />
    </g>
  </svg>
);
export default MealTagsIcon;
